'use strict';

export default class ModalStore {

    constructor() {
        this.bindActions(this.alt.getActions('modals'));
        this.openModal = false;
        this.data = false;
    }

    onCloseModals() {
        this.openModal = false;
        this.data = false;
    }

    onOpenModal(modal) {
        this.openModal = modal;
        this.data = false;
    }

    onOpenMediaModal(media) {
        this.data = media;
        this.openModal = 'Media';
    }

    onConfirmModal(data) {
        this.openModal = 'Confirm';
        this.data = data;
    }

    onOpenInstantDownloadModal(media) {
        this.data = media;
        this.openModal = 'InstantDownload';
    }

    onOpenWatermarkModal(media) {
        this.data = media;
        this.openModal = 'Watermark';
    }

    onToggleDownload(fileKey) {
        var item = this.data;
        var files = item.get('files').map( (file) => {
            if ( file.get('key') !== fileKey ) {
                return file;
            }
            return file.set('_selected', !file.get('_selected'));
        });

        this.data = this.data.set( 'files', files );
    }

    onGenerateDownload() {
        // console.log('generate download', this.data.get('files').filter((file) => {
        //     return file.get('_selected') ? file : false;
        // }).toJS());
    }

    static getSelectedInstantDownloadItems() {
        if ( !this.state.data ) {
            return [];
        }

        var selectedItems = [...this.state.data.get('files').toJS()];
        return selectedItems.filter( file => !!file._selected );
    }
}



// WEBPACK FOOTER //
// ./app/stores/modalStore.js